import type { FC } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { UpsellGlpText } from 'generated/resources/datatable.graphql'

interface GlpTextBlockProps {
  block: UpsellGlpText
}

export const GlpTextBlock: FC<GlpTextBlockProps> = ({ block }) => {
  if (!block) {
    return null
  }

  return (
    <Box gap="s8">
      {block.title && (
        <Text size="400" weight="bold" color="black">
          {block.title}
        </Text>
      )}
      {block.description && <Text size="300">{block.description}</Text>}
    </Box>
  )
}
